import React from "react"
import styled from "styled-components"

import { useModal } from "../hooks/modal"

const Button = styled.button`
  position: relative;
  display: block;
  width: 100%;
  height: 0;
  padding: 100% 0 0;
  border: 0;
  border-radius: 50%;
  background-color: white;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  overflow: hidden;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  animation: answer-button-fade-in 0.5s forwards;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 42.85%, rgba(0, 0, 0, 0.4) 100%);
  }

  @keyframes answer-button-fade-in {
    0%    { opacity: 0; }
    100%  { opacity: 1; }
  }
`

const Text = styled.span`
  display: block;
  position: absolute;
  bottom: 0.75rem;
  left: 0;
  z-index: 2;
  width: 100%;
  padding: 0.25rem 18%;
  color: white;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8125rem;
  line-height: 0.875rem;
  font-weight: 700;
  text-shadow: 0 0.0625rem 0.3125rem rgba(0, 0, 0, 0.25);
`

export default function QuestionPanelAnswerButton({ lang, question, activeItemIndex, videoTitle, item }) {
  const { openModal } = useModal()

  return (
    <Button
      style={{ backgroundImage: item.image ? `url(${encodeURI(item.image)}?nf_resize=fit&w=320)` : "none" }}
      onClick={(e) => openModal(e, "video", {
        lang,
        id: item.video_id,
        title: videoTitle,
      })}
    >
      <Text>
        {item.name}
      </Text>
      <span className="structural">: {question}</span>
    </Button>
  )
}
